import { State } from "../types";

export type HideTableUIAction = Readonly<{
  type: "HIDE TABLE UI";
}>;

export const hideTableUI = (state: State, _action: HideTableUIAction): State => {
  if (!state.showTableUI) {
    return state;
  }
  return {
    ...state,
    showTableUI: false,
  };
};
